import DatesFormat from '@/util/classes/datesFormat';
const dateFormat: DatesFormat = new DatesFormat();

export const formatDate = (date: string): string => {
  return dateFormat.formatDate(date);
};

export const dateTime = (date: string): string => {
  return dateFormat.formatDateTime(date);
};

export const moneyFormat = (money: number): string => {
  const formatter = new Intl.NumberFormat('en-US',
    { style: 'currency', currency: 'USD', }
  );
  return formatter.format(money);
};

export const moneyCents = (money: number): string => {
  money = money / 100;
  const formatter = new Intl.NumberFormat('en-US',
    { style: 'currency', currency: 'USD', }
  );
  return formatter.format(money);
};

export function formatDateDMY(dateValue: string | Date | null | undefined): string {
  if (!dateValue) return '';

  const date = new Date(dateValue);

  // Check if the date is valid
  if (isNaN(date.getTime())) return '';

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}
